<template>
  <div>
    <b-modal
      ref="searchTemplate"
      cancel-variant="outline-danger"
      @ok.prevent="saveSearch"
      :ok-disabled="isSubmitting"
      @hidden="$emit('hidden')"
      size="lg"
      hide-footer
      modal-class="template-modal"
    >
      <template #modal-header>
        <h5 class="font-bold">保存した検索条件</h5>
        <button type="button" class="close" @click="hide">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="template-container">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th style="min-width: 150px">検索条件名</th>
                <th style="min-width: 120px">初期検索条件</th>
                <th style="min-width: 140px">検索条件の反映</th>
                <th style="min-width: 140px">検索条件の編集</th>
                <th style="min-width: 100px">削除</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="template in templates" :key="template.id">
                <td style="vertical-align: middle">
                  {{ template.title }}
                </td>
                <td style="vertical-align: middle">
                  <div class="d-flex justify-content-center align-items-center">
                    <label class="switch mb-0">
                      <input
                        type="checkbox"
                        :checked="template.is_default"
                        @change="
                          ($event) =>
                            handleDefaultToggle(template, $event.target.checked)
                        "
                      />
                      <span class="slider round"></span>
                    </label>
                    <span class="ml-2">{{ template.is_default ? 'ON' : 'OFF' }}</span>
                  </div>
                </td>
                <td style="vertical-align: middle">
                   <button class="btn btn-reflect btn-sm" @click="openSearchReflect(template)">
                    反映
                  </button>
                </td>
                <td style="vertical-align: middle">
                  <button class="btn btn-edit btn-sm" @click="editTemplate(template)">
                    編集
                  </button>
                </td>
                <td style="vertical-align: middle">
                  <button class="btn btn-delete btn-sm" @click="showDeleteConfirmation(template)">
                    削除
                  </button>
                </td>
                <EditSearchTemplate
                  v-if="selectedTemplate && selectedTemplate.id === template.id"
                  :template="template"
                  :showModal="isModalEdit"
                  @hideSearchModal="hideSearchModal"
                />
              </tr>
              <tr v-if="!templates.length">
                <td colspan="100%" class="text-center">
                  テンプレートが見つかりません。
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
    <confirmation-modal
      ref="deleteConfirmation"
      message="この検索条件を削除しますか？"
      @confirm="confirmDelete"
      @cancel="cancelDelete"
    />
  </div>
</template>

<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import ConfirmationModal from '@/components/utils/ConfirmationModal.vue';
import EditSearchTemplate from '../../../views/EditSearchTemplate.vue';
import { mapMutations } from 'vuex';
import mutations from '@/config/mutations';
export default {
  name: 'SearchTemplateModal',
  components: {
    ConfirmationModal,
    EditSearchTemplate,
  },
  props: {
    templates: {
      type: Array,
      required: true,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    fromHomePage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      templateToDelete: null,
      isModalEdit: false,
      selectedTemplate: null,
      isSearchReflect: false,
    };
  },
  methods: {
    ...mapMutations(['mutateSearchTemplateAfterChange', 'unsetTemplate', mutations.applicant.CHANGE_SEARCH_PARAMS]),
    openSearchReflect(template) {
      if(template.search) {
        // Instead of using CHANGE_SEARCH_PARAMS, directly populate the form models
        this[mutations.applicant.CHANGE_SEARCH_PARAMS](template.search);
      }
      this.$refs.searchTemplate.hide();
    },
    show() {
      this.$refs.searchTemplate.show();
    },
    hide() {
      this.$refs.searchTemplate.hide();
      this.$emit('hidden');
    },
    showDeleteConfirmation(template) {
      this.templateToDelete = template;
      this.$refs.deleteConfirmation.show();
    },
    cancelDelete() {
      this.templateToDelete = null;
    },
    async confirmDelete(template) {
      if (this.templateToDelete) {
        try {
          await ApiService.delete(
            Api.endpoints.DELETE_TEMPLATE(this.templateToDelete.id)
          );
          this.unsetTemplate(this.templateToDelete);
        } catch (error) {
          console.error('Error deleting template:', error);
        }
        this.templateToDelete = null;
      }
    },
    async handleDefaultToggle(template, isChecked) {
      // Remember original state before changes
      const wasDefault = template.is_default;

      // Update UI immediately
      this.templates.forEach((t) => {
        if (isChecked && t.id !== template.id) {
          t.is_default = false;
        } else if (t.id === template.id) {
          t.is_default = isChecked;
        }
      });

      try {
        // Call API if we're changing the default status (either setting or unsetting)
        if (isChecked || wasDefault) {
          const { data } = await ApiService.get(
            Api.endpoints.TEMPLATE_STATUS_CHANGE(template.id)
          );
          this.mutateSearchTemplateAfterChange(data.data);
        }
      } catch (error) {
        console.error('Error updating default template:', error);
        // Restore previous state on error - assuming loadTemplates() exists
        // this.loadTemplates();

        // Or manually revert to previous state
        this.templates.forEach((t) => {
          if (t.id === template.id) {
            t.is_default = wasDefault;
          }
        });
      }
    },
    // async handleDefaultChange(template) {
    //   try {
    //     const { data } = await ApiService.get(
    //       Api.endpoints.TEMPLATE_STATUS_CHANGE(template.id)
    //     );
    //     this.mutateSearchTemplateAfterChange(data.data);
    //   } catch (error) {
    //     console.error('Error updating default template:', error);
    //   }
    // },
    hideSearchModal(isHideTemplate) {
      this.isModalEdit = false; // Hide the modal
      this.selectedTemplate = null; // Clear the selected template
      if (isHideTemplate) {
        this.hide();
      }
    },
    editTemplate(template) {
      this.isSearchReflect = false;
      this.selectedTemplate = template; // Set the selected template
      this.isModalEdit = true; // Show the modal
    },
  },
};
</script>

<style scoped>
.template-container {
  max-height: 500px;
  overflow-y: auto;
}
.template-modal .modal-body {
  padding: 0px !important;
}
table th {
  text-align: center;
  background-color: #f8f9fa;
  font-weight: bold;
  font-size: 14px;
}
table td {
  text-align: center;
  font-size: 14px;
}

/* Switch Styles */
.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* Button Styles */
.btn-reflect {
  background-color: #268e83; /* Teal color resembling the image */
  color: white;
  border: none;
  min-width: 60px;
  border-radius: 4px;
  font-size: 12px;
}
.btn-reflect:hover {
  background-color: #1e7067;
  color: white;
}

.btn-edit {
  background-color: #e9ecef; /* Light grey */
  color: #495057;
  border: none;
  min-width: 60px;
  border-radius: 4px;
  font-size: 12px;
}
.btn-edit:hover {
  background-color: #ced4da;
}

.btn-delete {
  background-color: transparent;
  color: #dc3545;
  border: 1px solid #dc3545;
  min-width: 60px;
  border-radius: 4px;
}
.btn-delete:hover {
  background-color: #dc3545;
  color: white;
}
</style>
